import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime, objectSpread2 as _objectSpread2, slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { PropTypes } from 'prop-types';
import { PaginationComponent } from '../PaginationComponent.js';
import { FieldGroup } from './FieldGroup.js';
import { CheckboxControl } from './Controls/CheckboxControl.js';
import { i18n } from '../../i18n/translate.js';
import { getPageSize } from '../../utils/pageSize.js';
import { getData } from '../../json-api/JsonApiUtils.js';
import isEqual from 'lodash/isEqual.js';
import set from 'lodash/set.js';
import { SearchComponent } from './SearchComponent.js';
import { Checkbox } from './Controls/Checkbox/Checkbox.js';
import { getTotalCount } from '../../utils/totalCount.js';
import { selectAll } from '../../utils/selectAll.js';
import { ProgressSpinner } from '../progress-spinner/component.js';

var AsyncCheckboxList = /*#__PURE__*/function (_React$Component) {
  function AsyncCheckboxList(props) {
    var _this;

    _classCallCheck(this, AsyncCheckboxList);

    _this = _callSuper(this, AsyncCheckboxList, [props]);

    _defineProperty(_this, "getData", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(filters) {
        var resetPagination,
            _this$props,
            dataUrl,
            dataInclude,
            pageSize,
            filterField,
            sortBy,
            authToken,
            defaultRelationData,
            queryFields,
            _this$state,
            activePage,
            search,
            formData,
            nextPage,
            _args2 = arguments;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                resetPagination = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
                _this$props = _this.props, dataUrl = _this$props.dataUrl, dataInclude = _this$props.dataInclude, pageSize = _this$props.pageSize, filterField = _this$props.filterField, sortBy = _this$props.sortBy, authToken = _this$props.authToken, defaultRelationData = _this$props.defaultRelationData, queryFields = _this$props.queryFields;
                _this$state = _this.state, activePage = _this$state.activePage, search = _this$state.search, formData = _this$state.formData;
                nextPage = resetPagination ? 1 : activePage;

                _this.setState({
                  isLoading: true
                }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                  var query, _yield$getData, data, meta, newFormData;

                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (queryFields && search) {
                            query = {
                              name: {
                                term: search,
                                fields: queryFields
                              }
                            };
                          }

                          _context.next = 3;
                          return getData(dataUrl, {
                            authToken: authToken,
                            includes: dataInclude,
                            filters: _objectSpread2(_objectSpread2({}, filters), filterField && search && !queryFields ? _defineProperty({}, filterField, search) : undefined),
                            sorts: sortBy && [{
                              value: sortBy,
                              direction: 'asc'
                            }],
                            page: {
                              number: nextPage,
                              size: pageSize
                            },
                            query: query
                          });

                        case 3:
                          _yield$getData = _context.sent;
                          data = _yield$getData.data;
                          meta = _yield$getData.meta;
                          newFormData = _objectSpread2({}, formData);

                          if (defaultRelationData) {
                            data.forEach(function (relation) {
                              var key = relation.id;
                              newFormData[key] = newFormData[key] || {};
                              newFormData[key].relation = Object.assign({}, defaultRelationData(relation, key), newFormData[key].relation);
                            });
                          }

                          if (_this.props.onDataLoaded) _this.props.onDataLoaded(data);

                          _this.setState({
                            isLoading: false,
                            formData: newFormData,
                            totalCount: getTotalCount((meta === null || meta === void 0 ? void 0 : meta.total_count) || data.length),
                            valueList: data,
                            valueOverride: false,
                            activePage: nextPage
                          });

                        case 10:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_this, "itemCount", function () {
      var formData = _this.state.formData;
      if (!formData) return 0;
      return Object.values(formData).filter(function (value) {
        return value && value.checked;
      }).length;
    });

    _defineProperty(_this, "selectedKeys", function (formData) {
      return Object.entries(formData).filter(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2);

        _ref5[0];
        var value = _ref5[1];
        return value && value.checked;
      }).map(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
            key = _ref7[0];

        _ref7[1];
        return key;
      });
    });

    _defineProperty(_this, "clearAll", function () {
      var formData = _this.state.formData;
      var newFormData = Object.keys(formData || {}).reduce(function (acc, key) {
        acc[key].checked = false;
        return acc;
      }, _objectSpread2({}, formData));

      _this.handleChange(newFormData);
    });

    _defineProperty(_this, "handleSelectAll", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _this$props2, dataUrl, filters, dataEntity, sortBy, authToken, _this$state2, formData, totalCount, selectedIds, newFormData;

      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props2 = _this.props, dataUrl = _this$props2.dataUrl, filters = _this$props2.filters, dataEntity = _this$props2.dataEntity, sortBy = _this$props2.sortBy, authToken = _this$props2.authToken;
              _this$state2 = _this.state, formData = _this$state2.formData, totalCount = _this$state2.totalCount;

              _this.setState({
                isLoading: true
              });

              _context3.next = 5;
              return selectAll({
                endpoint: dataUrl,
                filters: filters,
                isChecked: true,
                totalCount: totalCount,
                selectedIds: [],
                entity: dataEntity,
                sortValue: sortBy,
                authToken: authToken
              });

            case 5:
              selectedIds = _context3.sent;

              _this.setState({
                isLoading: false
              });

              newFormData = selectedIds.reduce(function (cache, value) {
                cache[value] = cache[value] || {};
                cache[value].checked = true;
                return cache;
              }, _objectSpread2({}, formData));

              _this.handleChange(newFormData);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_this, "onValueChange", function (keyValue) {
      var _Object$entries$ = _slicedToArray(Object.entries(keyValue)[0], 2),
          key = _Object$entries$[0],
          value = _Object$entries$[1];

      var formData = _objectSpread2({}, _this.state.formData);

      set(formData, key, value);

      _this.handleChange(formData);
    });

    _defineProperty(_this, "handleChange", function (formData) {
      var _this$props3 = _this.props,
          relationKey = _this$props3.relationKey,
          onChange = _this$props3.onChange,
          valueOverride = _this$props3.valueOverride;
      var existingRelations = _this.state.existingRelations;

      var selectedKeys = _this.selectedKeys(formData);

      var selectedKeyMap = selectedKeys.reduce(function (accumulator, key) {
        return _objectSpread2(_objectSpread2({}, accumulator), {}, _defineProperty({}, key, true));
      }, {});

      if (relationKey) {
        var activeRelations = selectedKeys.map(function (key) {
          return Object.assign({
            id: existingRelations[key]
          }, formData[key].relation);
        });
        var toDeleteRelations = Object.entries(existingRelations).filter(function (_ref9) {
          var _ref10 = _slicedToArray(_ref9, 2),
              id = _ref10[0];

          _ref10[1];
          return !selectedKeyMap[id];
        }).map(function (_ref11) {
          var _ref12 = _slicedToArray(_ref11, 2);

          _ref12[0];
          var relationId = _ref12[1];
          return {
            id: relationId,
            _destroy: true
          };
        });
        var relations = activeRelations.concat(toDeleteRelations);
        if (onChange) onChange(relations);
      } else {
        if (onChange) onChange(selectedKeys);
      }

      if (!valueOverride) {
        _this.setState({
          formData: formData
        });
      }
    });

    _defineProperty(_this, "handleSearch", function (value) {
      var _this$state3;

      if ((value === null || value === void 0 ? void 0 : value.search) === ((_this$state3 = _this.state) === null || _this$state3 === void 0 ? void 0 : _this$state3.search)) return false;

      _this.setState(_objectSpread2(_objectSpread2({}, value), {}, {
        activePage: 1
      }), function () {
        _this.getData(_this.props.filters);
      });
    });

    _defineProperty(_this, "clearSearch", function () {
      _this.clearAll();

      _this.setState({
        valueOverride: true,
        search: ''
      }, function () {
        return _this.getData(_this.props.filters);
      });
    });

    _defineProperty(_this, "handlePageChange", function (eventKey) {
      _this.setState({
        activePage: eventKey
      }, function () {
        _this.getData(_this.props.filters);
      });
    });

    _defineProperty(_this, "handleRadioChange", function (event) {
      _this.setState({
        formData: {
          selected: event.target.value
        }
      });

      if (_this.props.onRadioChange) {
        _this.props.onRadioChange(event.target.value);
      }
    });

    _defineProperty(_this, "noItemsChecked", function () {
      var formData = _this.state.formData;

      if (!Object.keys(formData || {}).length) {
        return true;
      }

      return !Object.values(formData || {}).some(function (val) {
        return val && val.checked;
      });
    });

    _defineProperty(_this, "renderCustomRowItem", function (key, value, element) {
      var _this$props4 = _this.props,
          disabled = _this$props4.disabled,
          renderRow = _this$props4.renderRow,
          singleSelect = _this$props4.singleSelect;
      var formData = _this.state.formData;
      var isSelected = !!formData && (singleSelect ? formData.selected === key : (formData[key] || {}).checked);
      var row = renderRow(element, "".concat(key, "[relation]"), disabled || !((formData === null || formData === void 0 ? void 0 : formData[key]) || {}).checked, value, key, isSelected);
      return row || null;
    });

    _defineProperty(_this, "renderItems", function () {
      var _this$props5 = _this.props,
          valueKey = _this$props5.valueKey,
          labelKey = _this$props5.labelKey,
          labelFunction = _this$props5.labelFunction;
      _this$props5.dataValue;
      var disabled = _this$props5.disabled,
          renderRow = _this$props5.renderRow,
          CheckboxComponent = _this$props5.CheckboxComponent,
          singleSelect = _this$props5.singleSelect,
          name = _this$props5.name,
          readOnlyList = _this$props5.readOnlyList,
          dataObjectType = _this$props5.dataObjectType,
          dataObjectAction = _this$props5.dataObjectAction,
          dataObjectAttribute = _this$props5.dataObjectAttribute,
          uniqueKey = _this$props5.uniqueKey;
      var _this$state4 = _this.state,
          valueList = _this$state4.valueList,
          formData = _this$state4.formData;

      if (!valueList.length) {
        return /*#__PURE__*/React.createElement("div", {
          className: "m-t-5 m-b-5 no-results"
        }, i18n.t('No results found'));
      }

      return valueList.map(function (value) {
        var key = value[valueKey];
        var label = typeof labelFunction === 'function' ? labelFunction(value) : value[labelKey];
        var element = singleSelect ? /*#__PURE__*/React.createElement(Checkbox, {
          checkClassName: "radio m-t-5 m-b-5",
          "data-object-action": dataObjectAction,
          "data-object-attribute": dataObjectAttribute,
          "data-object-id": key,
          "data-object-type": dataObjectType,
          isChecked: (formData === null || formData === void 0 ? void 0 : formData.selected) === key,
          isDisabled: disabled,
          key: key,
          labelClassName: "m-l-10",
          name: name,
          onChange: _this.handleRadioChange,
          type: "radio",
          value: key
        }, label) : /*#__PURE__*/React.createElement(FieldGroup, {
          className: "m-l-15"
        }, /*#__PURE__*/React.createElement(CheckboxComponent, {
          key: key,
          valueOverride: true,
          id: uniqueKey && "".concat(uniqueKey, "_").concat(key),
          name: "".concat(key, "[checked]"),
          "data-object-type": dataObjectType,
          "data-object-id": key,
          "data-object-attribute": dataObjectAttribute,
          "data-object-action": dataObjectAction,
          disabled: disabled || readOnlyList && readOnlyList.includes(key)
        }, label));
        return typeof renderRow === 'function' ? _this.renderCustomRowItem(key, value, element) : element;
      });
    });

    _defineProperty(_this, "renderHeader", function () {
      var _this$props6 = _this.props,
          heading = _this$props6.heading,
          headingLevel = _this$props6.headingLevel,
          showSelectOptions = _this$props6.showSelectOptions,
          singleSelect = _this$props6.singleSelect,
          dataObjectType = _this$props6.dataObjectType,
          dataObjectAttribute = _this$props6.dataObjectAttribute;
      return /*#__PURE__*/React.createElement("div", {
        className: "checkbox-list-header"
      }, heading ? _this.renderHeadingLevel("".concat(heading, " *"), headingLevel) : null, !singleSelect && showSelectOptions && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "select-all",
        onClick: _this.handleSelectAll,
        "data-object-type": dataObjectType,
        "data-object-attribute": dataObjectAttribute,
        "data-object-action": "select-all-".concat(dataObjectType)
      }, i18n.t('Select All')), /*#__PURE__*/React.createElement("span", null, _this.itemCount(), " ", i18n.t('Selected')), /*#__PURE__*/React.createElement("span", {
        className: "clear-all",
        onClick: _this.clearAll,
        "data-object-type": dataObjectType,
        "data-object-attribute": dataObjectAttribute,
        "data-object-action": "clear-all-".concat(dataObjectType)
      }, i18n.t('Clear'))));
    });

    _defineProperty(_this, "renderHeadingLevel", function (content, level) {
      if (!content) return null;

      switch (level) {
        case 1:
          return /*#__PURE__*/React.createElement("h1", null, content);

        case 2:
          return /*#__PURE__*/React.createElement("h2", null, content);

        case 3:
          return /*#__PURE__*/React.createElement("h3", null, content);

        case 4:
          return /*#__PURE__*/React.createElement("h4", null, content);

        case 5:
          return /*#__PURE__*/React.createElement("h5", null, content);

        case 6:
          return /*#__PURE__*/React.createElement("h6", null, content);

        default:
          return null;
      }
    });

    _defineProperty(_this, "renderPagination", function () {
      var _this$props7 = _this.props,
          pageSize = _this$props7.pageSize,
          maxPageButtons = _this$props7.maxPageButtons;
      var _this$state5 = _this.state,
          totalCount = _this$state5.totalCount,
          activePage = _this$state5.activePage;
      var siblingPagesRange = (maxPageButtons - 3) / 2;
      return totalCount > pageSize ? /*#__PURE__*/React.createElement("div", {
        className: "text-center"
      }, /*#__PURE__*/React.createElement(PaginationComponent, {
        currentPage: activePage,
        totalPages: Math.ceil(totalCount / pageSize),
        hidePreviousAndNextPageLinks: true,
        hideFirstAndLastPageLinks: true,
        siblingPagesRange: siblingPagesRange,
        onChange: _this.handlePageChange
      })) : null;
    });

    _defineProperty(_this, "renderFooter", function () {
      var renderClearFilters = _this.props.renderClearFilters;
      return /*#__PURE__*/React.createElement(React.Fragment, null, _this.renderPagination(), !_this.noItemsChecked() && !!renderClearFilters && renderClearFilters(_this.clearAll));
    });

    _defineProperty(_this, "renderSearch", function () {
      var _this$props8 = _this.props,
          filterField = _this$props8.filterField,
          queryFields = _this$props8.queryFields,
          searchCaption = _this$props8.searchCaption,
          dataObjectType = _this$props8.dataObjectType,
          dataObjectAttribute = _this$props8.dataObjectAttribute,
          searchWrapperClasses = _this$props8.searchWrapperClasses;

      if (filterField || queryFields) {
        var placeholder = "".concat(i18n.t('Search'), " ").concat(searchCaption);
        return /*#__PURE__*/React.createElement(SearchComponent, {
          name: "search",
          placeholder: placeholder,
          searchAction: _this.handleSearch,
          wrapperClass: searchWrapperClasses,
          "data-object-type": dataObjectType,
          "data-object-attribute": dataObjectAttribute,
          "data-object-action": "".concat(dataObjectAttribute, "-search")
        });
      }
    });

    _defineProperty(_this, "renderBody", function () {
      var _this$state6 = _this.state,
          formData = _this$state6.formData,
          isLoading = _this$state6.isLoading;
      var content = isLoading ? /*#__PURE__*/React.createElement(ProgressSpinner, null) : /*#__PURE__*/React.createElement(FieldGroup, {
        className: "withScroll",
        data: formData,
        onValueChange: _this.onValueChange
      }, _this.renderItems());
      return /*#__PURE__*/React.createElement("div", {
        className: "select-wrapper"
      }, _this.renderSearch(), _this.props.middlePanel, /*#__PURE__*/React.createElement("div", {
        className: "list-content"
      }, content));
    });

    var initialState = {
      valueList: [],
      activePage: 1,
      totalCount: null,
      isLoading: false,
      valueOverride: false
    };
    _this.state = addFormDataToState(_this.props, initialState);
    return _this;
  }

  _inherits(AsyncCheckboxList, _React$Component);

  return _createClass(AsyncCheckboxList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getData(this.props.filters);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!isEqual(this.props.filters, prevProps.filters)) {
        this.getData(this.props.filters, true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "checkbox-list ".concat(this.props.className)
      }, this.renderHeader(), this.renderBody(), this.renderFooter());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.valueOverride) {
        return addFormDataToState(props, state);
      } else {
        return state;
      }
    }
  }]);
}(React.Component);

_defineProperty(AsyncCheckboxList, "propTypes", {
  className: PropTypes.string,
  heading: PropTypes.string,
  headingLevel: PropTypes.number,
  showSelectOptions: PropTypes.bool,
  disabled: PropTypes.bool,
  dataUrl: PropTypes.string,
  dataInclude: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  dataObjectAction: PropTypes.string,
  dataObjectAttribute: PropTypes.string,
  dataObjectType: PropTypes.string,
  dataValue: PropTypes.string,
  authToken: PropTypes.string,
  valueKey: PropTypes.string.isRequired,
  labelKey: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onRadioChange: PropTypes.func,
  labelFunction: PropTypes.func,
  relationKey: PropTypes.string,
  filters: PropTypes.object,
  filterField: PropTypes.string,
  renderClearFilters: PropTypes.func,
  renderRow: PropTypes.func,
  // (checkboxElement, fieldGroupName, disabled, value, key, isSelected)
  defaultRelationData: PropTypes.func,
  pageSize: PropTypes.number,
  queryFields: PropTypes.object,
  maxPageButtons: PropTypes.number,
  sortBy: PropTypes.string,
  CheckboxComponent: PropTypes.func,
  dataEntity: PropTypes.string,
  searchWrapperClasses: PropTypes.string,
  singleSelect: PropTypes.bool,
  name: PropTypes.string,
  searchCaption: PropTypes.string,
  middlePanel: PropTypes.element,
  valueOverride: PropTypes.bool,
  readOnlyList: PropTypes.array,
  onDataLoaded: PropTypes.func,
  uniqueKey: PropTypes.string
});

_defineProperty(AsyncCheckboxList, "defaultProps", {
  headingLevel: 4,
  relationValueKeys: [],
  maxPageButtons: 5,
  pageSize: getPageSize(),
  showSelectOptions: true,
  searchChangeDelay: 1000,
  CheckboxComponent: CheckboxControl,
  searchCaption: '',
  searchWrapperClasses: 'full-width m-b-5'
});

AsyncCheckboxList.displayName = "AsyncCheckboxList";

function addFormDataToState(props, state) {
  var selectedValues = props.selectedValues,
      singleSelect = props.singleSelect,
      relationKey = props.relationKey,
      relationValueKeys = props.relationValueKeys;

  if (state.formData && Object.keys(state.formData || {}).length) {
    Object.keys(state.formData || {}).forEach(function (key) {
      state.formData[key].checked = false;
    });
    selectedValues.forEach(function (key) {
      if (state.formData[key]) {
        state.formData[key].checked = true;
      } else {
        state.formData[key] = {
          checked: true
        };
      }
    });
  } else {
    state.formData = singleSelect ? {
      selected: selectedValues
    } : getFormDataFromSelectedValues(selectedValues, relationKey, relationValueKeys);
  }

  if (relationKey) {
    state.existingRelations = selectedValues.reduce(function (accumulator, selection) {
      return _objectSpread2(_objectSpread2({}, accumulator), {}, _defineProperty({}, selection[relationKey], selection.id));
    }, {});
  }

  return state;
}

function getFormDataFromSelectedValues(selectedValues, relationKey, relationValueKeys) {
  return selectedValues.reduce(function (accumulator, selection) {
    var valueObject = {
      checked: true
    };

    if (relationKey) {
      valueObject.relation = relationValueKeys.reduce(function (relationObject, valueKey) {
        return _objectSpread2(_objectSpread2({}, relationObject), {}, _defineProperty({}, valueKey, selection[valueKey]));
      }, {});
    }

    return _objectSpread2(_objectSpread2({}, accumulator), {}, _defineProperty({}, relationKey ? selection[relationKey] : selection, valueObject));
  }, {});
}

export { AsyncCheckboxList };